import { createSelector } from "@reduxjs/toolkit";

import { initialState } from "./slice";

const selectDomain = (state) => state.samplerEdit || initialState;

export const selectSamplerDetails = createSelector(
  [selectDomain],
  (state) => state.samplerDetails
);

export const selectError = createSelector(
  [selectDomain],
  (state) => state.error
);

export const selectLoading = createSelector(
  [selectDomain],
  (state) => state.loading
);

export const selectDistricts = createSelector(
  [selectDomain],
  (state) => state.districts
);

export const selectStates = createSelector(
  [selectDomain],
  (state) => state.states
);

export const selectAgencies = createSelector(
  [selectDomain],
  (state) => state.agencies
);

export const selectDistrictsOfMultipleStates = createSelector(
  [selectDomain],
  (state) => state.districtsOfMultipleStates
);